import React from 'react';
import { useAppStore } from '../store/useAppStore';
import { clearAuthData } from '../utils/authUtils';
import { getRedirectUrl } from '../utils/helpers';

const NoAuthPage = () => {
  const { reset } = useAppStore();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      clearAuthData();
      reset();
      const redirectUrl = getRedirectUrl('/login');
      window.location.replace(redirectUrl);
    }, 1500);

    return () => clearTimeout(timer);
  }, [reset]);

  return (
    <div className='min-h-screen flex items-center justify-center' style={{ background: 'var(--bg-base)' }}>
      <div
        className='max-w-md w-full rounded-xl p-8 text-center shadow-xl'
        style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
      >
        <div className='mb-6'>
          <div
            className='mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4'
            style={{ background: 'rgba(239,68,68,0.12)' }}
          >
            <svg
              className='w-8 h-8'
              style={{ color: '#ef4444' }}
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z'
              />
            </svg>
          </div>
          <h1 className='text-2xl font-bold mb-2' style={{ color: 'var(--text-primary)' }}>
            Authentication Failed
          </h1>
          <p style={{ color: 'var(--text-muted)' }}>
            We couldn&apos;t verify your access. This could be due to an expired or invalid token.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoAuthPage;
